













import Vue from 'vue'
import config from '@/config'

export default Vue.extend({
  name: 'NotFound',
  computed: {
    isApp(): boolean {
      return sessionStorage.getItem('isApp') === '1'
    },

    href(): string {
      // アプリ内ブラウザからのアクセスなら
      if (this.isApp) {
        return `${config.SERVER_URL}/urlscheme.php?path=/home`
        // アプリ内なら
      } else if (typeof cordova !== 'undefined') {
        return '#/home'
        // Web なら
      } else {
        return config.MOBILE_URL
      }
    },

    buttonLabel(): string {
      return this.isApp ? 'アプリに戻る' : 'ホームに戻る'
    }
  }
})
